export const getMoodSubnav = (projectId: string, moodId: string) => {

  return [
    {
      title: 'Points of Interest',
      to: `/project/${projectId}/mood/${moodId}`
    },
    {
      title: 'Mood Journey Details',
      to: `/project/${projectId}/mood/${moodId}/mood-details`
    },
    {
      title: 'Translations',
      to: `/project/${projectId}/mood/${moodId}/translations`
    }
  ]
}
